import { LANGUAGE_COLORS } from './constants';

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  var plural = function (n, unit) { return n + ' ' + unit + (n === 1 ? '' : 's') + ' ago'; };
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return plural(diffDays, 'day');
  if (diffDays < 30) return plural(Math.floor(diffDays / 7), 'week');
  if (diffDays < 365) return plural(Math.floor(diffDays / 30), 'month');
  return plural(Math.floor(diffDays / 365), 'year');
};

export const getLanguageColor = (language) => {
  return LANGUAGE_COLORS[language] || '#8b949e';
};

export const formatNumber = (num) => {
  if (!num) return '0';
  if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
  if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
  return num.toString();
};

export const calculateLanguageStats = (repos) => {
  const langMap = {};
  repos.forEach((repo) => {
    if (repo.language) {
      langMap[repo.language] = (langMap[repo.language] || 0) + (repo.size || 1);
    }
  });

  const total = Object.values(langMap).reduce((sum, val) => sum + val, 0);

  return Object.entries(langMap)
    .map(([name, value]) => ({
      name,
      value,
      percentage: ((value / total) * 100).toFixed(1),
      color: getLanguageColor(name),
    }))
    .sort((a, b) => b.value - a.value)
    .slice(0, 10);
};

export const smoothScroll = (id) => {
  const element = document.getElementById(id);
  if (element) {
    const offset = 80;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
};